import { Injectable } from '@angular/core';
import {LoaderService} from "./loader.service";
import {Observable} from "rxjs/Observable";
import {Http} from "@angular/http";
import {ErrorService} from "./error.service";
import {PreloaderService} from "./preloader.service";

@Injectable()
export class AnimationsService extends LoaderService {

  private _intervalId;

  clearContent(_type:string, ownerId: string, ownerType: string, imgId:string): Observable<void> {
    const body = {_type, ownerId, ownerType, imgId };
    return this.sendPost("/animations/clear-content", body)
      .map(r => void 0);
  }

  uploadBlob(_type:string, ownerId: string, ownerType: string, imgId:string, content:any[])
  {
    const body = { _type, ownerId, ownerType, imgId, content};
    return this.sendPost("/animations/upload-blob", body);
  }

  updateContent(_type:string, ownerId: string, ownerType: string, imgId:string, content:string[]): Observable<any> {
    const body = { _type, ownerId, ownerType, imgId, content};
    return this.sendPost("/animations/update-content", body)
      .map(r => r);
  }

  loadInfo(_type:string, ownerId: string, ownerType: string, imgId:string): Observable<IAnimationInfo> {
    const body = { _type, ownerId, ownerType, imgId};
    return this.sendPost("/animations/load-info", body)
      .map(r => <IAnimationInfo>r.json());
  }

  runPacker():Observable<boolean>{
    console.log("send pack command");
    return this.sendPost("/animations/run-packer").map(r =>true);
  }

  startPackerStatusUpdate(){
    console.log("pack started");
    this.preloaderService.show();
    this._intervalId = setInterval(() => this.updatePackerState(), this.PACKER_STATE_INTERVAL);
  }

  updateDestinationAtlas(_type:string,
                          ownerId: string,
                         ownerType: string,
                         imgId:string,
                         atlas: string): Observable<boolean> {
    const body = { _type, ownerId, ownerType, imgId, atlas };
    return this.sendPost("/animations/set-atlas", body)
      .map(r => true);
  }

  private get PACKER_STATE_INTERVAL(): number { return 5000 };

  private updatePackerState() {
    // todo: use socket instead of http !!!
    this.load("/animations/get-state")
      .subscribe((r): void => {
        try {
          this.setPackerState(r.json().running);
        } catch (e) {
          console.log("packing error!");
          this.setPackerState(false);
        }
      });
  }

  private setPackerState(isBusy:boolean):void {
    if (!isBusy){
      this.preloaderService.hide();
      clearInterval(this._intervalId);
      console.log("pack ended");
    }
  }
}


export interface IAnimationInfo {
  ownerId: string;
  ownerType: string;
  atlas: string;
  content: any[];
  imgId?: string;
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/animations.service.ts